import axios from 'axios';


const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';

interface LoginAuditData {
    email: string;
    role: string;
    customerId?: string;
    userId?: string;
}

export const registerLogin = async (data: LoginAuditData) => {
    try {
        await axios.post(`${API_URL}/api/loginRegister`, data);
    } catch (error) {
        console.error("Error al registrar auditoría de login:", error);
    }
};